/**
 * @generated SignedSource<<5ad4b48af73ebb49459f5f1c33004207>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PropHouseAuctionStatus = "ACTIVE" | "EXECUTED" | "PENDING" | "PROPOSING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PropHouseAuctionRowFragment$data = {
  readonly currencyType: string;
  readonly fundingAmount: string;
  readonly numProposals: number;
  readonly numWinners: number;
  readonly number: number;
  readonly proposalEndTime: string;
  readonly startTime: string;
  readonly status: PropHouseAuctionStatus;
  readonly title: string;
  readonly votingEndTime: string;
  readonly " $fragmentSpreads": FragmentRefs<"PropHouseAuctionRowActivityFragment">;
  readonly " $fragmentType": "PropHouseAuctionRowFragment";
};
export type PropHouseAuctionRowFragment$key = {
  readonly " $data"?: PropHouseAuctionRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PropHouseAuctionRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropHouseAuctionRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votingEndTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fundingAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numWinners",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "proposalEndTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numProposals",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropHouseAuctionRowActivityFragment"
    }
  ],
  "type": "PropHouseAuction",
  "abstractKey": null
};

(node as any).hash = "05a76cd468010e551caebbfa87bea840";

export default node;
